import geraldPic from "@/public/images/artists/gerald.png";
import { Artist } from "@/types/types";

export const gerald = {
  id: "149",
  name: "Gerald",
  image: geraldPic,
  description: `Gerald's dramatic bass voice commands attention without overwhelming. It's a voice marked by both strength and refinement, delivering a balanced and controlled sound that suits the most demanding performances.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fgerald-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Classical", "Soundtrack", "Deep"],
      secondary: ["Bass"],
    },
    pitchRange: {
      categories: {
        low: "Bass",
        high: "High",
      },
      specific: {
        low: 36,
        high: 72,
      },
      sweetSpot: 48,
    },
  },
} as const satisfies Artist;
